/**
 * Photo formats the server accepts for public photos (listing photos,
 * avatars). HEIC/HEIF (iPhone) is converted by the server before storage.
 * Some browsers give HEIC files an empty type: the extension decides then.
 */
export const PHOTO_ACCEPT = 'image/jpeg,image/jpg,image/png,image/webp,image/heic,image/heif,.heic,.heif';

const PHOTO_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp', 'image/heic', 'image/heif'];

export const isAcceptedPhoto = (file) => {
  if (!file) return false;
  if (PHOTO_TYPES.includes(file.type)) return true;
  return !file.type && /\.(heic|heif)$/i.test(file.name || '');
};
